/*
 * SS-CUSTOM: range hero video
 *
 * WCAG 2.2.2 (Pause, Stop, Hide): anything that plays automatically for more
 * than five seconds needs a control to stop it. The loop is also paused
 * outright for anyone who has asked their OS for reduced motion, and paused
 * while the tab is hidden so it is not burning battery in the background.
 */
(function () {
  'use strict';

  var video = document.getElementById('ss-range-hero-video');
  if (!video) return;

  var playBtn = document.querySelector('[data-rhero-playpause]');
  // a clip with no sound has no mute button
  var muteBtn = document.querySelector('[data-rhero-mute]');
  if (!playBtn) return;

  var iconPause = playBtn.querySelector('[data-icon-pause]');
  var iconPlay = playBtn.querySelector('[data-icon-play]');

  function showPaused(paused) {
    iconPause.style.display = paused ? 'none' : '';
    iconPlay.style.display = paused ? '' : 'none';
    playBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
  }

  playBtn.addEventListener('click', function () {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  if (muteBtn) muteBtn.addEventListener('click', function () {
    var iconMuted = muteBtn.querySelector('[data-icon-muted]');
    var iconUnmuted = muteBtn.querySelector('[data-icon-unmuted]');
    video.muted = !video.muted;
    iconMuted.style.display = video.muted ? '' : 'none';
    iconUnmuted.style.display = video.muted ? 'none' : '';
    muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
  });

  // keep the icon honest even if playback changes without a button press
  video.addEventListener('play', function () {
    showPaused(false);
  });
  video.addEventListener('pause', function () {
    showPaused(true);
  });

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function applyMotionPreference() {
    if (reduceMotion.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
  }
  applyMotionPreference();
  reduceMotion.addEventListener('change', applyMotionPreference);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      video.pause();
    } else if (!reduceMotion.matches) {
      video.play().catch(function () {});
    }
  });
})();
